<template>
    <div class="quote-description">
        <button
            v-if="isLong"
            type="button"
            class="description-expand"
            aria-label="Open full description"
            title="Open full description"
            @click.stop="$emit('open-description', description)"
        >
            <font-awesome-icon :icon="['fas', 'arrow-up-right-from-square']" />
        </button>
        <span v-if="isLong && !expanded">{{ preview }}</span>
        <div v-else class="description-html" v-html="safeHtml"></div>
        <button
            v-if="isLong"
            type="button"
            class="toggle-description"
            :aria-expanded="expanded"
            @click="expanded = !expanded"
        >
            {{ expanded ? 'show less' : 'show more' }}
        </button>
    </div>
</template>

<script>
    import { descriptionHtml, descriptionText } from '@/helpers/string'

    const PREVIEW_LENGTH = 90

    export default {
        name: 'QuoteDescription',
        emits: ['open-description'],
        props: {
            description: { type: String, default: '' },
        },
        data() {
            return { expanded: false }
        },
        computed: {
            safeHtml() {
                return descriptionHtml(this.description)
            },
            characters() {
                return Array.from(descriptionText(this.description))
            },
            isLong() {
                return this.characters.length > PREVIEW_LENGTH
            },
            preview() {
                return this.characters.slice(0, PREVIEW_LENGTH).join('') + '...'
            },
        },
        watch: {
            description() {
                this.expanded = false
            },
        },
    }
</script>

<style scoped>
    .quote-description {
        position: relative;
        padding-right: 1.75rem;
        max-width: 24rem;
        white-space: normal;
        overflow-wrap: anywhere;
    }

    .description-expand {
        position: absolute;
        top: 0;
        right: 0;
        padding: 0.125rem 0.25rem;
        border: 0;
        background: none;
        color: var(--color-brand-primary);
        cursor: pointer;
    }

    .toggle-description {
        padding: 0;
        margin-left: 0.25rem;
        border: 0;
        background: none;
        color: var(--color-brand-primary);
        cursor: pointer;
        font: inherit;
        font-weight: 600;
    }

    .toggle-description:hover {
        text-decoration: underline;
    }

    .description-html {
        max-height: 30rem;
        overflow: auto;
        text-align: left;
    }

    .description-html :deep(table) {
        width: 100%;
        table-layout: fixed;
    }

    .description-html :deep(td),
    .description-html :deep(th) {
        padding: 0.25rem;
        vertical-align: top;
        text-align: left;
        border: 1px solid var(--color-border, #ddd);
    }

    /* The outer quote's customer accent must not affect nested vendor tables. */
    .quote-description .description-html :deep(table td:first-child) {
        border-left: 1px solid var(--color-border, #ddd) !important;
    }
</style>
